module.exports = __webpack_public_path__ + "static/media/covi_ppe_fac_shi.42df083d.png";